import axios from "axios";
import { auth } from "./firebase";

axios.interceptors.request.use(async (config) => {
  const u = auth.currentUser;
  const t = u ? await u.getIdToken() : localStorage.getItem("firebase_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

axios.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      const next = encodeURIComponent(
        window.location.pathname + window.location.search
      );
      window.location.replace(`/login?next=${next}`);
    }
    return Promise.reject(err);
  }
);

export default axios;
